import {Component, Inject} from '@angular/core';
import {MatDialogRef, MAT_DIALOG_DATA} from '@angular/material/dialog';
import {FormGroup, FormBuilder, Validators} from '@angular/forms';
import {AdminService} from "../../services/admin.service";
import Swal from "sweetalert2";

@Component({
  selector: 'app-user-dialog',
  templateUrl: './user-dialog.component.html',
  styleUrls: ['./user-dialog.component.scss']
})
export class UserDialogComponent {
  userForm: FormGroup;
  isEditMode = false;

  constructor(
    private fb: FormBuilder,
    private adminService: AdminService,
    public dialogRef: MatDialogRef<UserDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {
    this.isEditMode = !!data.user;

    this.userForm = this.fb.group({
      fullName: [data.user ? data.user.fullName : '', Validators.required],
      email: [data.user ? data.user.email : '', [Validators.required, Validators.email]],
      role: [data.user ? data.user.role[0].name : [], Validators.required],
      password: ['', this.isEditMode ? Validators.nullValidator : Validators.required]
    });
  }

  onSave(): void {
    if (this.userForm.valid) {
      let userData = this.userForm.value;

      userData.role = [userData.role];

      if (this.isEditMode && !userData.password) {
        delete userData.password;
      }

      if (this.isEditMode) {
        this.adminService.updateUser(this.data.user.id, userData).subscribe(() => {
          this.dialogRef.close(true);
        }, error => {
          Swal.fire({
            title: 'Error!',
            text: error.error.message,
            icon: 'error',
            confirmButtonText: 'OK',
          });
        });
      } else {
        this.adminService.createUser(userData).subscribe(() => {
          this.dialogRef.close(true);
        }, error => {
          Swal.fire({
            title: 'Error!',
            text: error.error.message,
            icon: 'error',
            confirmButtonText: 'OK',
          });
        });
      }
    }
  }

  onCancel(): void {
    this.dialogRef.close();
  }

  getDialogTitle(): string {
    return this.isEditMode ? 'Edit User' : 'Create User';
  }

  getUpdatePassword(): string {
    return this.isEditMode ? 'Update Password' : 'Password';
  }

  getEnterPassword(): string {
    return this.isEditMode ? 'Leave blank to keep current password' : 'Enter password';
  }

  getCreateOrUpdate(): string {
    return this.isEditMode ? 'Update' : 'Create';
  }

}
